import { ComponentProps, CSSProperties, FC, PropsWithChildren, useContext } from "react";
import { EnrollmentContext } from "@/state";

type ThemedH2Props = ComponentProps<"h2">;
type ThemedPProps = ComponentProps<"p">;

export const ThemedH2: FC<PropsWithChildren<ThemedH2Props>> = (props) => {
  const { children, style, ...headingProps } = props;
  const [state] = useContext(EnrollmentContext);
  const font = (state.experienceData?.theme as { font?: string } | undefined)?.font || "Source Sans 3";

  const themedStyle: CSSProperties = {
    fontFamily: font,
    fontWeight: 400,
    fontSize: "24px",
    color: "#ffffff",
    marginBottom: "8px",
    lineHeight: "32px",
    ...(style || {}),
  };

  return <h2 {...headingProps} style={themedStyle}>{children}</h2>;
};

export const ThemedP: FC<PropsWithChildren<ThemedPProps>> = (props) => {
  const { children, style, ...paragraphProps } = props;

  const themedStyle: CSSProperties = {
    fontFamily: "Source Sans 3",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 400,
    color: "#ffffff",
    ...(style || {}),
  };

  return <p {...paragraphProps} style={themedStyle}>{children}</p>;
};
